import axios from './axiosConfig';
import { COS_API_URL } from './config';

export const getPresignedUrl = (folder, filename, contentType, userId = null, originalFilename = null) => {
  const params = { filename, content_type: contentType };
  if (userId !== null) params.user_id = userId;
  if (originalFilename) params.original_filename = originalFilename;
  return axios.get(`${COS_API_URL}/presigned-url/${folder}`, { params });
};

export const uploadImageToCos = async (file, folder, userId = null) => {
  const presignedRes = await getPresignedUrl(folder, file.name || 'upload.jpg', file.type || 'image/jpeg', userId, file.name);
  const { upload_url, access_url } = presignedRes.data;
  await axios.put(upload_url, file, { headers: { 'Content-Type': file.type || 'image/jpeg' } });
  return access_url;
};

export const uploadAudioToCos = async (file, userId) => {
  // 去除文件名中的空格，避免语音识别失败
  const originalFilename = (file.name || 'upload.mp3').replace(/\s+/g, '');
  const presignedRes = await getPresignedUrl('audio', originalFilename, file.type || 'audio/mpeg', userId, originalFilename);
  const { upload_url, access_url } = presignedRes.data;
  await axios.put(upload_url, file, { headers: { 'Content-Type': file.type || 'audio/mpeg' } });
  return access_url;
};

export const uploadFileToCos = async (file, folder, contentType) => {
  const presignedRes = await getPresignedUrl(folder, file.name || 'upload.jpg', contentType || file.type || 'image/jpeg');
  const { upload_url, access_url } = presignedRes.data;
  await axios.put(upload_url, file, { headers: { 'Content-Type': contentType || file.type || 'image/jpeg' } });
  return access_url;
};

export const uploadVideoToCos = async (file, presignedData) => {
  const { upload_url, access_url } = presignedData;
  await axios.put(upload_url, file, {
    headers: { 'Content-Type': 'video/mp4' },
    onUploadProgress: (progressEvent) => {
      const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      console.log(`Video upload: ${percent}%`);
    }
  });
  return access_url;
};